exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-submit.disabled[data-v-2e48df75]{background:#efefef;color:rgba(0,0,0,.5);cursor:default}.size[data-v-2e48df75]{min-width:calc(100% - 60px)!important}", ""]);

// exports
